var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.292 13.405-3.234 3.228-3.069 3.067-1.133 1.129a7.627 7.627 0 0 1-10.673-.001A7.708 7.708 0 0 1 1 15.503a7.367 7.367 0 0 1 2.184-5.326 7.627 7.627 0 0 1 10.673 0l3.234 3.227-.08.08-.97.97-1.05 1.049-1.214 1.21-2.102 2.097a4.5 4.5 0 0 1-6.47 0 4.473 4.473 0 0 1 0-6.453 4.536 4.536 0 0 1 3.236-1.372 4.6 4.6 0 0 1 2.67.888c.206.14.396.303.567.484l.647.564-.89.89-4.445 4.436c.437.265.939.404 1.45.403.816 0 1.6-.318 2.183-.887l.162-.162 4.123-4.113-2.182-2.179A6.065 6.065 0 0 0 8.44 9.533a5.742 5.742 0 0 0-4.21 1.775 6.026 6.026 0 0 0 0 8.552 6.11 6.11 0 0 0 8.572 0l.161-.161.647-.647.323-.323 3.154-3.147 2.668-2.743.486-.483a4.596 4.596 0 0 1 7.873 3.227 4.6 4.6 0 0 1-2.854 4.256 4.596 4.596 0 0 1-5.02-1.03l-1.132-1.128 1.052-1.05 1.132 1.13a3.064 3.064 0 0 0 5.222-2.179 3.066 3.066 0 0 0-5.222-2.178zm-15.7.999c-.153.374-.23.776-.226 1.18 0 .574.168 1.135.486 1.613l4.205-4.195a2.92 2.92 0 0 0-1.617-.484 3.032 3.032 0 0 0-2.848 1.886zM23.479 8.08c1.994 0 3.91.783 5.336 2.18a7.364 7.364 0 0 1 2.183 5.323 7.367 7.367 0 0 1-2.184 5.326 7.627 7.627 0 0 1-10.673-.001l-1.132-1.13 1.052-1.049 1.133 1.13a6.052 6.052 0 0 0 9.88-6.586 6.055 6.055 0 0 0-1.31-1.966 6.11 6.11 0 0 0-8.57 0l-1.133 1.13-1.051-1.05 1.132-1.129a7.627 7.627 0 0 1 5.337-2.18z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErn);
export default __webpack_public_path__ + "static/media/ERN.4be88221a8b28f9ac68ecb06e436877e.svg";
export { ForwardRef as ReactComponent };